import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import Overview from "./Overview";
import Users from "./Users";
import Cases from "./Cases";
import Transactions from "./Transactions";
import Settings from "./Settings";
import Audit from "./Audit";

/**
 * Sous-routage /admin/*. Ajouter un futur module = une entree dans
 * modules.js + une <Route> ici, en reutilisant AdminLayout comme coquille
 * commune (header, navigation, titre/description du module actif).
 */
export default function AdminRoutes() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<Overview />} />
        <Route path="users" element={<Users />} />
        <Route path="cases" element={<Cases />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="audit" element={<Audit />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Route>
    </Routes>
  );
}
